import { createContext, useContext } from "react";

// Design System 2.0 (2026-10, Phase 1) — set once on a page container, every row-based
// component (Table, Tasks, Board cards) reads it via useDensity() or the matching CSS
// variables (--row-h/--row-text/--row-py/--row-px) set by the data-density attribute below.
const DensityContext = createContext("standard");

export function DensityProvider({ density = "standard", children, as: Tag = "div", className = "", ...rest }) {
  return (
    <DensityContext.Provider value={density}>
      <Tag data-density={density} className={className} {...rest}>
        {children}
      </Tag>
    </DensityContext.Provider>
  );
}

export function useDensity() {
  return useContext(DensityContext);
}
